// @ts-nocheck
import { createStyle } from '@gluestack-style/react';
import { BaseIconVariants } from './Icon';

export const CheckboxIcon = createStyle({
  variants: BaseIconVariants,
  ':checked': {
    color: '$primary900',
  },
  ':disabled': {
    opacity: 0.4,
  },
  _dark: {
    ':checked': {
      color: '$primary100',
    },
    ':disabled': {
      opacity: 0.4,
    },
  },
});
